import React from 'react';
import './Hero.css';
import FeaturesBar from '../FeaturesBar';

export default function HeroBanner({ robotImage }) {
  return (
    <section className="hero-section">

      {/* Background Image */}
      {robotImage && (
        <img
          className="hero-bg-robot"
          src={robotImage}
          alt="hero"
        />
      )}

      <div className="hero-overlay"></div>

      <div className="hero-content">

        <div className="hero-text">

          <div className="hero-badge">
            <span className="hero-badge-dot" />
            <span>Schools & Colleges — End-to-End Lab Setup</span>
          </div>

          <h1 className="hero-heading">
            Build Labs Where
            <span className="accent">Ideas  Become</span>
            Innovations.
          </h1>

          <div className="hero-divider"></div>

          <p className="hero-subtext">
            Industry-grade lab infrastructure, purpose-built for educational institutions
          </p>

          <a href="#lab-enquiry-form" className="hero-cta" onClick={(e) => {
  e.preventDefault();
  document.getElementById('lab-enquiry-form')?.scrollIntoView({ behavior: 'smooth' });
}}>
  Get a Free Consultation →
</a>

        </div>

      </div>

      <FeaturesBar />
    </section>
  );
}